"use client";

import * as React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const listItems = [{
  id: 6,
  text: "UNI EN ISO 9001: Qualità"
}, {
  id: 7,
  text: "UNI EN ISO 14001: Ambiente"
}, {
  id: 8,
  text: "UNI EN ISO 45001: Salute e Sicurezza sul lavoro"
}, {
  id: 9,
  text: "UNI EN ISO 27001: Sicurezza delle Informazioni"
}, {
  id: 10,
  text: "UNI EN ISO 37001: Anticorruzione"
}, {
  id: 11,
  text: "UNI EN ISO 50001: Energia"
}, {
  id: 12,
  text: "SA 8000: Responsabilità Sociale"
}, {
  id: 13,
  text: "UNI EN ISO 26000: Responsabilità Sociale"
}, {
  id: 14,
  text: "ISO 37301: Compliance"
}, {
  id: 15,
  text: "ISO/IEC 27701: Privacy"
}, {
  id: 16,
  text: "BRC; IFS: Sicurezza Alimentare"
}, {
  id: 17,
  text: "UNI EN ISO 22000: Sicurezza alimentare"
}, {
  id: 18,
  text: "UNI/PdR 125:2022: Politiche di parità di genere nelle organizzazioni"
}];
export default function ArchitectureTextContent() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1,
    once: true
  });
  return <section id="textcontent" className="py-32 overflow-hidden !bg-[hsl(222,47%,11%)]">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-12 gap-6">
          <div ref={ref} className={`col-span-12 md:col-span-10 md:col-start-2 lg:col-span-8 lg:col-start-3 flex flex-col items-center text-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <h2 className="article-title font-light text-3xl leading-tight mb-8 tracking-tight !text-left w-full max-w-[800px] !text-[hsl(0,0%,100%)] md:text-5xl lg:text-6xl">HSE, CYBERSECURITY AUDIT E CERTIFICAZIONI</h2>

            <Separator className="mb-8 bg-white/20 w-full max-w-3xl" />

            <div className="flex flex-col items-center">
              <p className="font-sans text-lg leading-relaxed max-w-3xl mb-6 !text-justify !text-[hsl(0,0%,100%)] md:text-xl">Lo Studio DCLegal, attraverso la partnership con la società di consulenza Development Compliance Partner s.r.l., è in grado di assistere i propri clienti negli adempimenti in materia di:<br /><br />- salute e sicurezza sui luoghi di lavoro;
              <div>- ambiente;
              </div><div>- salute e sicurezza alimentare;
              </div><div>- cybersecurity (adeguamento NIS2, DORA, ecc.)
              </div><div>- attività di audit;
              </div><div>- ottenimento delle certificazioni, in particolare, secondo i seguenti standard:</div></p>
              
              <ul className="font-sans text-lg leading-relaxed max-w-3xl mb-12 !text-left !text-[hsl(0,0%,100%)] md:text-xl space-y-2 list-disc list-inside">
                {listItems.map((item, i) => <li key={item.id} data-index={i} className={item.id > 5 ? "ml-6 list-[circle]" : ""}>
                    {item.text}
                  </li>)}
              </ul>
            </div>

            <Button asChild variant="outline" size="lg" className="font-mono uppercase tracking-wider text-xs rounded-none border-border hover:bg-accent hover:text-accent-foreground transition-colors">
              
            </Button>
          </div>
        </div>
      </div>
    </section>;
}